<section class="input-lab">
  <header class="input-lab__header">
    <h1>Laboratório do app-input</h1>
    <p>Página de teste para acompanhar eventos, mudanças de valor e possíveis loops.</p>
    <div class="input-lab__actions">
      <button appButton buttonType="outline" label="Limpar logs" (click)="clearLogs()"></button>
      <button
        appButton
        buttonType="primary"
        label="Resetar estados"
        (click)="resetAllStates()"></button>
    </div>
  </header>

  <section class="input-lab__group input-lab__group--ngmodel">
    <h2 class="input-lab__group-title">Cenários com ngModel</h2>
    <div class="input-lab__grid">
      <article class="input-lab__card">
        <h3>1) Texto simples (ngModel)</h3>
        <app-input
          label="Texto"
          placeholder="Digite um texto"
          [(ngModel)]="ngModelTextValue"
          (ngModelChange)="onNgModelChange('ngModel-text', $event)"
          (sendInputValue)="onOutput('ngModel-text.sendInputValue', $event)"
          (sendInputStatus)="onOutput('ngModel-text.sendInputStatus', $event)"></app-input>
        <pre>{{ ngModelTextValue | json }}</pre>
        <pre class="input-lab__card-log">{{ getScenarioLogText('ngModel-text') }}</pre>
      </article>

      <article class="input-lab__card">
        <h3>2) Número (ngModel)</h3>
        <app-input
          label="Número"
          type="number"
          prefix="R$ "
          [minFractionDigits]="2"
          [maxFractionDigits]="2"
          [(ngModel)]="ngModelNumberValue"
          (ngModelChange)="onNgModelChange('ngModel-number', $event)"
          (sendInputValue)="onOutput('ngModel-number.sendInputValue', $event)"
          (sendInputStatus)="onOutput('ngModel-number.sendInputStatus', $event)"></app-input>
        <pre>{{ ngModelNumberValue | json }}</pre>
        <pre class="input-lab__card-log">{{ getScenarioLogText('ngModel-number') }}</pre>
      </article>

      <article class="input-lab__card">
        <h3>3) CNPJ (ngModel)</h3>
        <app-input
          label="CNPJ"
          type="cnpj"
          [unmask]="true"
          placeholder="00.000.000/0000-00"
          [(ngModel)]="ngModelCnpjValue"
          (ngModelChange)="onNgModelChange('ngModel-cnpj', $event)"
          (sendInputValue)="onOutput('ngModel-cnpj.sendInputValue', $event)"
          (sendInputStatus)="onOutput('ngModel-cnpj.sendInputStatus', $event)"></app-input>
        <pre>{{ ngModelCnpjValue | json }}</pre>
        <pre class="input-lab__card-log">{{ getScenarioLogText('ngModel-cnpj') }}</pre>
      </article>

      <article class="input-lab__card">
        <h3>4) Máscara customizada (ngModel)</h3>
        <app-input
          label="CEP"
          type="useMask"
          mask="99999-999"
          [unmask]="false"
          placeholder="00000-000"
          [(ngModel)]="ngModelMaskValue"
          (ngModelChange)="onNgModelChange('ngModel-mask', $event)"
          (sendInputValue)="onOutput('ngModel-mask.sendInputValue', $event)"
          (sendInputStatus)="onOutput('ngModel-mask.sendInputStatus', $event)"></app-input>
        <pre>{{ ngModelMaskValue | json }}</pre>
        <pre class="input-lab__card-log">{{ getScenarioLogText('ngModel-mask') }}</pre>
      </article>

      <article class="input-lab__card">
        <h3>5) Textarea (ngModel)</h3>
        <app-input
          label="Descrição"
          type="textarea"
          placeholder="Digite a descrição"
          [(ngModel)]="ngModelTextAreaValue"
          (ngModelChange)="onNgModelChange('ngModel-textarea', $event)"
          (sendInputValue)="onOutput('ngModel-textarea.sendInputValue', $event)"
          (sendInputStatus)="onOutput('ngModel-textarea.sendInputStatus', $event)"></app-input>
        <pre>{{ ngModelTextAreaValue | json }}</pre>
        <pre class="input-lab__card-log">{{ getScenarioLogText('ngModel-textarea') }}</pre>
      </article>

      <article class="input-lab__card">
        <h3>6) Password (ngModel)</h3>
        <app-input
          label="Senha"
          type="password"
          placeholder="Digite sua senha"
          [(ngModel)]="ngModelPasswordValue"
          (ngModelChange)="onNgModelChange('ngModel-password', $event)"
          (sendInputValue)="onOutput('ngModel-password.sendInputValue', $event)"
          (sendInputStatus)="onOutput('ngModel-password.sendInputStatus', $event)"></app-input>
        <pre>{{ ngModelPasswordValue | json }}</pre>
        <pre class="input-lab__card-log">{{ getScenarioLogText('ngModel-password') }}</pre>
      </article>

      <article class="input-lab__card">
        <h3>7) Loading (ngModel)</h3>
        <app-input
          label="Input com loading"
          [loading]="ngModelLoading"
          placeholder="Exemplo de spinner"
          [(ngModel)]="ngModelLoadingValue"
          (ngModelChange)="onNgModelChange('ngModel-loading', $event)"
          (sendInputValue)="onOutput('ngModel-loading.sendInputValue', $event)"
          (sendInputStatus)="onOutput('ngModel-loading.sendInputStatus', $event)"></app-input>
        <pre>{{ { loading: ngModelLoading, value: ngModelLoadingValue } | json }}</pre>
        <pre class="input-lab__card-log">{{ getScenarioLogText('ngModel-loading') }}</pre>
      </article>
    </div>
  </section>

  <section class="input-lab__group input-lab__group--form">
    <h2 class="input-lab__group-title">Cenários com FormGroup</h2>
    <div class="input-lab__grid">
      <article class="input-lab__card">
        <h3>8) Texto (FormGroup)</h3>
        <form [formGroup]="form">
          <app-input
            label="Texto (FormGroup)"
            [formGroup]="form"
            controlName="text"
            (sendInputValue)="onOutput('form-text.sendInputValue', $event)"
            (sendInputStatus)="onOutput('form-text.sendInputStatus', $event)"></app-input>
        </form>
        <pre>{{ form.get('text')?.value | json }}</pre>
        <pre class="input-lab__card-log">{{ getScenarioLogText('form-text') }}</pre>
      </article>

      <article class="input-lab__card">
        <h3>9) Número (FormGroup)</h3>
        <form [formGroup]="form">
          <app-input
            label="Número (FormGroup)"
            type="number"
            [minFractionDigits]="2"
            [maxFractionDigits]="2"
            [formGroup]="form"
            controlName="number"
            (sendInputValue)="onOutput('form-number.sendInputValue', $event)"
            (sendInputStatus)="onOutput('form-number.sendInputStatus', $event)"></app-input>
        </form>
        <pre>{{ form.get('number')?.value | json }}</pre>
        <pre class="input-lab__card-log">{{ getScenarioLogText('form-number') }}</pre>
      </article>

      <article class="input-lab__card">
        <h3>10) CNPJ (FormGroup)</h3>
        <form [formGroup]="form">
          <app-input
            label="CNPJ (FormGroup)"
            type="cnpj"
            [unmask]="true"
            [formGroup]="form"
            controlName="cnpj"
            (sendInputValue)="onOutput('form-cnpj.sendInputValue', $event)"
            (sendInputStatus)="onOutput('form-cnpj.sendInputStatus', $event)"></app-input>
        </form>
        <pre>{{ form.get('cnpj')?.value | json }}</pre>
        <pre class="input-lab__card-log">{{ getScenarioLogText('form-cnpj') }}</pre>
      </article>

      <article class="input-lab__card">
        <h3>11) Máscara customizada (FormGroup)</h3>
        <form [formGroup]="form">
          <app-input
            label="CEP (FormGroup)"
            type="useMask"
            mask="99999-999"
            [formGroup]="form"
            controlName="mask"
            (sendInputValue)="onOutput('form-mask.sendInputValue', $event)"
            (sendInputStatus)="onOutput('form-mask.sendInputStatus', $event)"></app-input>
        </form>
        <pre>{{ form.get('mask')?.value | json }}</pre>
        <pre class="input-lab__card-log">{{ getScenarioLogText('form-mask') }}</pre>
      </article>

      <article class="input-lab__card">
        <h3>12) Textarea (FormGroup)</h3>
        <form [formGroup]="form">
          <app-input
            label="Descrição (FormGroup)"
            type="textarea"
            [formGroup]="form"
            controlName="textarea"
            (sendInputValue)="onOutput('form-textarea.sendInputValue', $event)"
            (sendInputStatus)="onOutput('form-textarea.sendInputStatus', $event)"></app-input>
        </form>
        <pre>{{ form.get('textarea')?.value | json }}</pre>
        <pre class="input-lab__card-log">{{ getScenarioLogText('form-textarea') }}</pre>
      </article>

      <article class="input-lab__card">
        <h3>13) Password (FormGroup)</h3>
        <form [formGroup]="form">
          <app-input
            label="Senha (FormGroup)"
            type="password"
            [formGroup]="form"
            controlName="password"
            (sendInputValue)="onOutput('form-password.sendInputValue', $event)"
            (sendInputStatus)="onOutput('form-password.sendInputStatus', $event)"></app-input>
        </form>
        <pre>{{ form.get('password')?.value | json }}</pre>
        <pre class="input-lab__card-log">{{ getScenarioLogText('form-password') }}</pre>
      </article>
    </div>
  </section>

  <section class="input-lab__logs">
    <h2>Log de eventos</h2>
    <pre *ngIf="logs.length === 0">Sem eventos ainda.</pre>
    <pre *ngIf="logs.length > 0">{{ logs.join('\n') }}</pre>
  </section>
</section>
